export default __webpack_public_path__ + "static/media/mender-show.2affdf4b.png";